import { useAppStore } from '@/stores'

export const useDataLayerHelpers = () => {
  const appStore = useAppStore()

  const getLastSlugPart = (url: string) => {
    if (!url) return '/'
    return url.split('/').pop()
  }

  const getPageType = () => {
    return appStore.cmsData.slug || 'ivestors_relations'
  }

  return { getPageType, getLastSlugPart }
}
